import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchJson } from "../utils/fetchJson";

export default function NewsPage() {
  const [news, setNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // ---- 新增：分页器相关状态 ----
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6; // 每页条数，可自行修改

  useEffect(() => {
    handleNews();
  }, []);

  const handleNews = () => {
    setIsLoading(true);
    setError(null);

    fetchJson("/json/carousel.json")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch news");
        return response.json();
      })
      .then((data) => {
        const sortedNews = data.sort((a, b) => {
          return new Date(b.time) - new Date(a.time);
        });

        setNews(sortedNews);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setIsLoading(false);
      });
  };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formatYMDToEnglish = (dateStr, type = "us") => {
    const ymdRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!ymdRegex.test(dateStr)) return dateStr;

    const [year, month, day] = dateStr.split("-").map(Number);
    const monthName = monthNames[month - 1];
    const dayNum = day.toString().replace(/^0/, "");

    return type === "uk"
      ? `${dayNum} ${monthName} ${year}`
      : `${monthName} ${dayNum}, ${year}`;
  };

  if (isLoading) return <p className="text-center mt-10">Loading...</p>;
  if (error) return <p className="text-center mt-10 text-red-500">{error}</p>;

  // ---- 计算分页后的数据 ----
  const totalPages = Math.ceil(news.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const currentPageNews = news.slice(startIndex, startIndex + pageSize);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div className="page-title">
        <h1>News</h1>
      </div>

      {currentPageNews.map((item) => (
        <Link
          to={`/news/${item.id}`}
          key={item.id}
          className="text-decoration-none text-dark"
        >
          <div
            className="card mb-3 shadow-sm border-0"
            style={{ cursor: "pointer" }}
          >
            <div className="row g-0">
              {/* 左侧图片 */}
              <div className="col-md-6">
                <div
                  className="image-box"
                  style={{
                    height: "300px",
                    width: "100%",
                    background: "#f2f3f5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    borderRadius: "8px",
                  }}
                >
                  {/* 真正的图片 */}
                  <img
                    src={item?.new_image || item?.image}
                    alt={item.title}
                    style={{
                      maxWidth: "96%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              </div>

              {/* 右侧文字 */}
              <div className="col-md-6 d-flex">
                <div
                  className="card-body"
                  style={{
                    position: "relative",
                    paddingBottom: "40px",
                  }}
                >
                  <h5
                    className="card-title mb-0"
                    style={{
                      fontWeight: "bold",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item.title}
                  </h5>

                  <p style={{ marginTop: "10px", textAlign: "justify" }}>
                    {item.description_1}
                  </p>

                  <span
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                      fontSize: "0.9rem",
                      color: "#777",
                    }}
                  >
                    {formatYMDToEnglish(item.time)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Link>
      ))}

      {/* ---------------- 分页器 ---------------- */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center ">
          <nav>
            <ul className="pagination">
              {/* 上一页 */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link custom-page"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
              </li>

              {/* 页码 */}
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link custom-page"
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}

              {/* 下一页 */}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link custom-page"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </div>
  );
}
